<script lang="ts" setup>
withDefaults(
  defineProps<{
    iconName: string
    iconClass?: object | string | null
    text?: string | null
    title: string
    withHover?: boolean
  }>(),
  { iconClass: null, text: null, withHover: false }
)

const emit = defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <div class="relative text-center">
    <div class="relative">
      <Indicator v-if="text" class="right-0" :value="text" />

      <SvgIcon
        class="!size-6"
        :class="[iconClass, { 'with-hover': withHover }]"
        :name="iconName"
        @click="emit('click')"
      />
    </div>

    <div class="text-[11px] leading-[1.2] text-main-dark">
      {{ title }}
    </div>
  </div>
</template>

